// src/broadcast/utils/channel.ts

/**
 * Channel name prefix
 */
const CHANNEL_PREFIX = 'user'
const CHANNEL_SUFFIX = 'broadcast'

/**
 * Generate the channel name for a user
 * @param userId - User's unique identifier
 * @returns Formatted channel name
 */
export function getChannelName(userId: string): string {
  if (!userId || typeof userId !== 'string') {
    throw new Error('Invalid userId: must be a non-empty string')
  }
  return `${CHANNEL_PREFIX}:${userId}:${CHANNEL_SUFFIX}`
}

/**
 * Parse user ID from channel name
 * @param channelName - Full channel name
 * @returns User ID or null if invalid format
 */
export function parseChannelName(channelName: string): string | null {
  const pattern = new RegExp(`^${CHANNEL_PREFIX}:(.+):${CHANNEL_SUFFIX}$`)
  const match = channelName.match(pattern)
  return match ? match[1] : null
}

/**
 * Validate channel name format
 * @param channelName - Channel name to validate
 * @returns True if valid format
 */
export function isValidChannelName(channelName: string): boolean {
  return parseChannelName(channelName) !== null
}
